<div class="modal fade" data-bs-backdrop="static" data-bs-keyboard="false" [id]="modalName" tabindex="-1" aria-labelledby="renewModalLabel" aria-hidden="true">
  <div class="modal-dialog modal-xl modal-dialog-centered modal-dialog-scrollable">
    <div #modalContent class="modal-content glassmorphism-card rounded-lg px-2 px-lg-5 py-3">
      <div class="modal-header border-bottom-0 pb-0">
        <h4 class="modal-title font-weight-bold" id="renewModalLabel">تجديد الإشتراك</h4>
        <button (click)="changeStatusToClosed(modalName)" #closeButton type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close" title="إغلاق"></button>
      </div>

      <div class="modal-body">
        <!-- Current Plan -->
        <h5 class="decorated font-weight-bold mt-5 mt-lg-0"><span>الباقة الحالية</span></h5>
        <app-loader-spinner [color]="'success'" *ngIf="isLoading"></app-loader-spinner>

        <ng-container *ngIf="!isLoading">
          <div class="row h-100 mt-4 mb-5">
            <div class="col-6 col-lg-3 mx-auto">
              <app-voucher
                [filled]="true"
                [name]="currentQuotaDescription?.name"
                [price]="currentQuotaDescription?.price"
                [speed]="currentQuotaDescription?.speed"
                [quota]="currentQuotaDescription?.quota"
                [quotaUnit]="currentQuotaDescription?.quota_unit"
                [limited]="currentQuotaDescription?.type?.toLowerCase() !== 'unlimited'">
              </app-voucher>
            </div>
          </div>
        </ng-container>

        <ng-container *ngIf="!isLoading">
          <!-- Step 1: Select Offers -->
          <ng-container *ngIf="step === 1">
            <h5 class="mb-5">اختر باقتك</h5>

            <!-- Quota Selection Buttons -->
            <div class="mb-5 offer-buttons" [class.scrollable]="isScrollable">
              <div #quotaButtons class="offer-scroll">
                <button *ngFor="let offer of quotaOffers; let i = index"
                        class="btn offer-button"
                        [class.btn-very-light]="i !== selectedQuotaIndex"
                        [class.btn-success]="i === selectedQuotaIndex"
                        (click)="updateSelection('quota', i)">
                  {{ offer.descriptionParsed?.quota }} {{ offer.descriptionParsed?.quota_unit }}
                </button>
              </div>
            </div>

            <!-- Days Selection Buttons -->
            <div class="mb-5 offer-buttons" [class.scrollable]="isScrollable">
              <div #daysButtons class="offer-scroll">
                <button *ngFor="let offer of daysOffers; let i = index"
                        class="btn offer-button"
                        [class.btn-very-light]="i !== selectedDaysIndex"
                        [class.btn-success]="i === selectedDaysIndex"
                        (click)="updateSelection('days', i)">
                  {{ offer.descriptionParsed?.exp }} {{ offer.descriptionParsed?.exp_unit }}
                </button>
              </div>
            </div>

            <!-- Selected Offers Summary -->
            <div class="selected-summary">
              <h5>باقتك:</h5>
              <p>
                (
                {{ selectedQuota?.descriptionParsed?.quota }} {{ selectedQuota?.descriptionParsed?.quota_unit }}
                )
                +
                (
                {{ selectedDays?.descriptionParsed?.exp }} {{ selectedDays?.descriptionParsed?.exp_unit }}
                )
              </p>
            </div>

            <div class="total-container">
              <h4><span class="text-success">{{ totalPrice }} دل</span></h4>
            </div>

            <button class="btn btn-success w-auto rounded-pill mx-auto pt-0 px-4 mt-2"
                    (click)="changeStep(2)"
                    [disabled]="isLoading || isSending">
              <ng-container *ngIf="isLoading || isSending">
                <div class="spinner-border spinner-border-sm" role="status">
                  <span class="sr-only">Loading...</span>
                </div>
              </ng-container>
              تجديد الاشتراك
            </button>
          </ng-container>

          <!-- Step 2: Confirmation -->
          <ng-container *ngIf="step === 2">
            <h5>تأكيد التفعيل</h5>
            <p>
              باقتك:
              (
              {{ selectedQuota?.descriptionParsed?.quota }} {{ selectedQuota?.descriptionParsed?.quota_unit }}
              )
              +
              (
              {{ selectedDays?.descriptionParsed?.exp }} {{ selectedDays?.descriptionParsed?.exp_unit }}
              )
            </p>
            <h4><span class="text-success">{{ totalPrice }} دل</span></h4>
            <button (click)="changeStep(1)"
                    class="btn btn-outline-dark w-auto rounded-pill mx-auto pt-0 px-4 mt-2 me-2"
                    [disabled]="isLoading">رجوع</button>
            <button (click)="activateOffer()"
                    class="btn btn-success w-auto rounded-pill mx-auto pt-0 px-4 mt-2"
                    [disabled]="isLoading">تأكيد</button>
          </ng-container>
        </ng-container>
      </div>
    </div>
  </div>
</div>
